<div class="modal-header">
  <div class="w-100">
    <div class="row align-items-center">
      <div class="col">
        <h4 class="modal-title" translate>Change password</h4>
      </div>
      <div class="col-auto">
        <button (click)="onClose()" aria-label="Close" class="close" type="button">
          <span aria-hidden="true" class="fa-solid fa-xmark"></span>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="form-group">
      <label for="password">
        <span translate>New password</span>
        <span class="ml-1 label-required">*</span>
      </label>
      <input [ngClass]="{ 'is-invalid': form.controls.password.errors }" formControlName="password" id="password"
        name="password" type="password" class="form-control">
        @if (form.controls.password.errors) {
          <div class="invalid-feedback">
            @if (form.controls.password.errors.required) {
              <span translate>Password required</span>
            }
            @if (form.controls.password.errors.pattern) {
              <span
              translate>The password must contain both letters and digits and must be at least 8 characters long</span>
            }
          </div>
        }
      </div>
      <div class="form-group">
        <label for="confirmPassword">
          <span translate>Confirm new password</span>
          <span class="ml-1 label-required">*</span>
        </label>
        <input [ngClass]="{ 'is-invalid': form.controls.confirmPassword.errors }" formControlName="confirmPassword"
          id="confirmPassword"
          name="confirmPassword" type="password" class="form-control">
          @if (form.controls.confirmPassword.errors) {
            <div class="invalid-feedback">
              @if (form.controls.confirmPassword.errors.required) {
                <span translate>Password required</span>
              }
              @if (form.controls.confirmPassword.errors.equal) {
                <span translate>Passwords must be identical</span>
              }
            </div>
          }
        </div>
      </form>
    </div>

    <scitis-modal-footer (cancelButtonPressed)="onCancel($event)"
      (okButtonPressed)="onOk($event)"
      [cancelButtonText]="cancelButtonText"
      [okButtonText]="okButtonText"
      [disableOkButton]="disableOkButton">
    </scitis-modal-footer>